import React from 'react';

const DetailsSection: React.FC = () => {
  return (
    <main className="px-4 md:px-6 py-8 md:py-10">
      <section className="max-w-[760px] mx-auto">
        <div className="text-[#192842] font-[500] text-[17px] leading-[1.33] tracking-[0.01em] space-y-5 mb-10 max-w-[640px] mx-auto text-left">
          <p>It is not unusual for mining companies to return 200%, 500%, or even 1,000%.</p>
          <p>
            The resource sector is known for its volatility—both on the downside and on the upside—for a reason.
          </p>
          <p>It can be a bumpy ride—and my The Wealthy Miner subscribers know that.</p>
          <p>
            They also know that being ahead of the crowd in the resource space can pay off handsomely.
          </p>
          <p>
            Below, I will show you three examples and the reasons why these stocks soared. Hope you find this analysis helpful. To get my next 10x candidate recommendation, I invite you to{' '}
            <a
              href="https://the-wealthy-miner.mn.co/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-[#0066FF] underline font-[700]"
            >
              join
            </a>{' '}
            my The Wealthy Miner inner circle.
          </p>
        </div>

        <div className="relative w-[calc(100%+2rem)] ml-[-1rem] mr-[-1rem] md:w-auto md:ml-auto md:mr-auto bg-[#EFEFEF] border-0 md:border md:border-[#d0d0d0] rounded-none md:rounded-[8px] shadow-none md:shadow-[0_2px_10px_rgba(0,0,0,0.16)] pt-24 md:pt-24 pb-8 px-6 md:px-8 max-w-none md:max-w-[640px]">
          <div className="absolute top-0 md:top-[16px] left-0 md:left-[-10px] right-0 md:right-[-10px] bg-[#0c6a5f] text-white text-center py-2.5 md:py-3">
            <span className="hidden md:block absolute left-0 top-full w-0 h-0 border-t-[9px] border-t-[#000000] border-r-[9px] border-r-transparent transform rotate-90" />
            <span className="hidden md:block absolute right-0 top-full w-0 h-0 border-t-[9px] border-t-[#000000] border-l-[9px] border-l-transparent transform -rotate-90" />
            <p className="font-[700] tracking-[0.1em] text-[17px] md:text-[24px] leading-[1.05]">STORY #1</p>
            <p className="font-[700] text-[19px] md:text-[26px] leading-[1.1]">Arizona Sonoran Copper Company</p>
          </div>

          <div className="space-y-5 md:mt-5 text-[#000000] text-[16px] leading-[1.24] font-[500] tracking-[0.01em]">
            <p>Arizona is a copper story. It&apos;s a development-stage company.</p>
            <p>
              I said it in my The Wealthy Miner blog that copper companies are well-positioned not only for a bull
              market, but also for a financial crisis.
            </p>
            <p>
              In short, copper has become a defensive commodity. It has plenty of drivers and catalysts that should
              support its price even if the global economy doesn&apos;t grow as fast as some investors expect.
            </p>
            <p>
              Copper is used in infrastructure, electronics, and defense. These sectors aren&apos;t as cyclical as, say,
              consumer goods. And the world&apos;s demand for copper is poised to grow. On the supply side, however, the
              world needs one or two of the largest copper mines&apos; worth of output to keep up. This isn&apos;t going to
              happen.
            </p>
            <p>
              These secular trends and the company&apos;s own strong execution at its Cactus project created a success
              story that delivered in spades.
            </p>
            <p>
              Just over the past six months, Arizona has soared by almost 135%. This happened despite the ongoing chaos
              in the Middle East.
            </p>
            <p>
              Some say that copper is the new oil, and this company confirms that it might be the case. What oil did in
              the 20th century, copper could accomplish in this one. Both commodities have proven vital to global energy
              infrastructure. As the global energy mix changes, so does investors&apos; focus on the commodities that are
              part of it.
            </p>
            <p>
              At the company level, Arizona delivered a strong pre-feasibility study for its Cactus project last year.
              The project&apos;s after-tax net present value was a respectable $2.3 billion, with an after-tax internal
              rate of return (IRR) of about 23%.
            </p>
            <p>
              The project would pay for itself within the first five years of its estimated 22-year mine life. This
              mine life could increase, of course.
            </p>
            <p>
              Finally, the project looks economic even at lower copper prices. Its all-in sustaining cost (or AISC) is
              just $1.86 per pound of copper. Right now, the metal is trading at about $5.30, leaving plenty of room
              for profit margins. Just recently, Arizona was acquired by Hudbay Minerals, a mid-tier producer. The deal
              valued Arizona at almost $1.5 billion.
            </p>
            <p>
              This story reminds me that during commodity bull markets companies with real, measurable value tend to get
              rewarded through share price appreciation and through interest from potential buyers. Arizona did the work
              and got acquired at a billion-plus price tag. When I do my due diligence to bring a new stock
              recommendation to my The Wealthy Miner readers, I pay special attention to the economics of the project a
              company is working on. If project economics work based on realistic assumptions and I don&apos;t see any red
              flags in the company&apos;s economic studies and resource statements, I move it up my list of potential
              candidates.
            </p>
            <p>
              Arizona wasn&apos;t one of my recommendations, but its success is a reminder that proper execution will most
              likely attract market interest.
            </p>

            <div className="pt-2">
              <img
                src="/images/STORY1.webp"
                alt="Arizona Sonoran Copper Company"
                className="w-full h-auto"
              />
            </div>
          </div>
        </div>

        <div className="relative w-[calc(100%+2rem)] ml-[-1rem] mr-[-1rem] md:w-auto md:ml-auto md:mr-auto bg-[#EFEFEF] border-0 md:border md:border-[#d0d0d0] rounded-none md:rounded-[8px] shadow-none md:shadow-[0_2px_10px_rgba(0,0,0,0.16)] pt-24 md:pt-24 pb-8 px-6 md:px-8 max-w-none md:max-w-[640px] mt-10">
          <div className="absolute top-0 md:top-[16px] left-0 md:left-[-10px] right-0 md:right-[-10px] bg-[#D3A12A] text-white text-center py-2.5 md:py-3">
            <span className="hidden md:block absolute left-0 top-full w-0 h-0 border-t-[9px] border-t-[#000000] border-r-[9px] border-r-transparent transform rotate-90" />
            <span className="hidden md:block absolute right-0 top-full w-0 h-0 border-t-[9px] border-t-[#000000] border-l-[9px] border-l-transparent transform -rotate-90" />
            <p className="font-[700] tracking-[0.1em] text-[17px] md:text-[24px] leading-[1.05]">STORY #2</p>
            <p className="font-[700] text-[19px] md:text-[26px] leading-[1.1]">Lundin Gold</p>
          </div>

          <div className="space-y-5 md:mt-5 text-[#000000] text-[16px] leading-[1.24] font-[500] tracking-[0.01em]">
            <p>
              Lundin Gold is one of the legendary names in the resource space.
            </p>
            <p>
              Over the past five years, this company has generated a return of 860%.
              Lundin is a mid-tier producer focused on Ecuador.
            </p>
            <p>
              Now, some investors may shun some of the more exotic jurisdictions like Ecuador and opt for the more familiar US- and Canada-focused companies. I understand them, but they are making a mistake.
            </p>
            <p>
              Yes, there are a lot of opportunities in North America, including Mexico. And with the US government’s push for onshoring of critical and other minerals, some of the North American players are well-positioned to enjoy easy permitting processes and access to plentiful capital.
            </p>
            <p>
             However, Lundin Gold is a reminder that even companies working outside of most investors’ comfort zone can deliver life-changing returns.
The company delivered excellent financial results for 2025. Its production reached almost half a million ounces of gold that year and generated about $1.8 million in revenue. The company’s cash flow alone was over $1 billion.
            </p>
            <p>
             Better yet, Lundin has kept its costs in check. Its all-in sustaining cost in 2025 was a little over $1,000 per ounce. This means that the company benefited handsomely from high gold prices.
            </p>
            <p>
              I reminded my The Wealthy Miner readers that when it comes to gold, I favor production-stage stories these days. They are perfectly positioned to enjoy the current commodity supercycle and the secular gold bull market. As soon as the price of gold goes up, producers see it reflected on their financial statements.
            </p>
            <p>
              (Pro tip for resource investors: if you have positions in gold producers, see if they have any forward sales contracts or hedging in place. If they do, they will have to sell some of their output at prices decided on earlier. In a bull market, it almost always means that their sale price would be lower than spot. To benefit from a bull market to the maximum, a producer needs to be unhedged.)
            </p>
            <p>
              Lundin’s world-class Fruta del Norte project contains 5.3 million ounces of gold in its reserves. On top of that, these reserves are high-grade. The average grade of the Proven and Probable categories is about 7.1 grams per tonne gold.
            </p>
            <p>
              This is what I look for in both production- and development-stage stories. A real, measurable reserve or resource that features high grades and can support a profitable mine.
            </p>
            <p>
              Lundin Gold’s assets fit these requirements. This is why the company has soared almost 10x over the past several years.
            </p>
            <div className="pt-2">
              <img
                src="/images/STORY2.webp"
                alt="Lundin Gold"
                className="w-full h-auto"
              />
            </div>
          </div>
        </div>

        <div className="relative w-[calc(100%+2rem)] ml-[-1rem] mr-[-1rem] md:w-auto md:ml-auto md:mr-auto bg-[#EFEFEF] border-0 md:border md:border-[#d0d0d0] rounded-none md:rounded-[8px] shadow-none md:shadow-[0_2px_10px_rgba(0,0,0,0.16)] pt-24 md:pt-24 pb-8 px-6 md:px-8 max-w-none md:max-w-[640px] mt-10">
          <div className="absolute top-0 md:top-[16px] left-0 md:left-[-10px] right-0 md:right-[-10px] bg-[#1A2A44] text-white text-center py-2.5 md:py-3">
            <span className="hidden md:block absolute left-0 top-full w-0 h-0 border-t-[9px] border-t-[#000000] border-r-[9px] border-r-transparent transform rotate-90" />
            <span className="hidden md:block absolute right-0 top-full w-0 h-0 border-t-[9px] border-t-[#000000] border-l-[9px] border-l-transparent transform -rotate-90" />
            <p className="font-[700] tracking-[0.1em] text-[17px] md:text-[24px] leading-[1.05]">STORY #3</p>
            <p className="font-[700] text-[19px] md:text-[26px] leading-[1.1]">AbraSilver</p>
          </div>

          <div className="space-y-5 md:mt-5 text-[#000000] text-[16px] leading-[1.24] font-[500] tracking-[0.01em]">
            <p>
              AbraSilver was one of the few stories that completely changed my life.
            </p>
            <p>
              This company has delivered a 100x return to me and its early shareholders.
            </p>
            <p>
              It is focused on silver, another commodity that I prefer these days, along with gold and copper.
            </p>
            <p>
              Abra owns the Diablillos project in Argentina. Some of you may have stayed away from that country because of its chaotic government and runaway inflation, but resource investors should remember that sometimes the best opportunities lie, much like Lundin Gold’s Fruta del Norte, off the beaten path.
            </p>
            <p>
              One of the keys to Abra’s success was the consistent work it did to de-risk Diablillos. At the end of 2024, the company announced a pre-feasibility study that featured an after-tax net present value of about $747 million and an internal rate of return of over 27%.
            </p>
            <p>
              The project’s payback period was just two years, and the mine life was about 14 years.
            </p>
            <p>
              In other words, Diablillos looked profitable and big enough to catch investors’ attention. Its all-in sustaining cost was just $12.67 per ounce of silver.
            </p>
            <p>
              The company has recently updated its resource estimate for Diablillos. The project now features 199 million ounces of silver and 1.7 million ounces of gold in the Measured and Indicated categories.
            </p>
            <p>
              It has both the volume and the high grades to deliver strong economics.
              Abra is working to deliver a feasibility study this year.
            </p>
            <p>
              The company has made a lot of progress competently. I have been honored to be its director and investor.
            </p>
            <p>
              But the bigger lesson here is that Abra, much like other resource companies that delivered excellent investment returns, has the right asset at the right time.
            </p>
            <p>
              Abra de-risked Diablillos just as investors began paying closer attention to monetary metals such as gold and silver. It got a boost both from the technical work its team accomplished and from a shift in investor sentiment.
            </p>
            <p>
              The company’s market cap is about $1.2 billion these days. When I first got involved with it, it was about $5 million.
            </p>
            <p>
              A return like this is rare, I will admit. But investors who focus on the best players in the industry and receive competent advice and recommendations may encounter an opportunity like this as well.
            </p>
            <div className="pt-2">
              <img
                src="/images/STORY3.webp"
                alt="AbraSilver"
                className="w-full h-auto"
              />
            </div>
          </div>
        </div>

        <div className="mt-10 text-[#192842] font-[500] text-[17px] leading-[1.33] tracking-[0.01em] space-y-5 mb-4 max-w-[640px] mx-auto text-left">
          <p>
            My{' '}
            <a
              href="https://the-wealthy-miner.mn.co/"
              target="_blank"
              rel="noopener noreferrer"
              className="underline"
            >
              <strong><em>The Wealthy Miner</em></strong>
            </a>{' '}
            premium service focuses on what I potentially see as 10x candidates in the resource space.
          </p>
          <p>
            You don’t run into 100x opportunities every day. But by spreading your bets and staying disciplined and consistent, you increase your chances of seeing another life-changing story in your portfolio.
          </p>
          <p>Good investing,</p>
          <p>
            Rob Bruggeman, CFA
          </p>
        </div>
      </section>
    </main>
  );
};

export default DetailsSection;
